import moment from 'moment'
export function time_format(seconds=0,options={}){ 
  return moment().startOf('day').add(seconds,'seconds').format(options.format || 'HH:mm:ss')
}